.feature-stats-card-container {
    min-height: 241px;
    width: 100%;
}
